import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const ProtectedRoute = ({ children, roles }: { children: ReactNode, roles?: string[] }) => {
  const { user } = useAuth();
  if (!user || (roles && !roles.includes(user.role))) return <Navigate to="/login" />;
  return children;
};

export default ProtectedRoute;
